
class navbarMenu {
    constructor(node) {
        let self = this;
        self.node = node;
        self.behaviour();
    }

    behaviour() {
        let self = this;

        const scriptUrls = [
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js',
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js',
          ];

        window.initPackages(scriptUrls).then(() => {
            self.initMainMenu();
        }).catch((error) => {
            console.error(error);
        });

        
    }

    reInit() {
        let self = this;

        self.closeMainMenu();
        self.closeAllDropDownMenu();
        self.destroyMainMenu();
        self.behaviour();
    }

    initMainMenu() {
        let self = this;
        self.navbarButton = document.querySelector('.js-menu-button');
        self.navbarContent = self.node.querySelector('.js-navbar-content');

        self.toggleMainMenuReference = self.toggleMainMenu.bind(null, self);
        self.navbarButton.addEventListener('click', self.toggleMainMenuReference, false);
    }

    destroyMainMenu() {
        let self = this;

        if(self.navbarButton) {
            self.navbarButton.removeEventListener('click',  self.toggleMainMenuReference, false);
        }
    }

    toggleMainMenu(self) {
        self.navbarContent.dataset.opened === "true" ? self.closeMainMenu() : self.openMainMenu();
    }

    openMainMenu() {
        let self = this;

        self.navbarButton.classList.add('open');
        self.navbarContent.dataset.opened = "true";
        self.navbarContent.classList.remove('hidden');
        self.node.classList.add('js-navbar--opened');
        document.querySelector('body').classList.add('overflow-hidden');
        gsap.from(self.navbarContent, {duration: 0.3, autoAlpha:0, right: '-100%'});
    }

    closeMainMenu() {
        let self = this;
       
        if(self.navbarButton && self.navbarButton.classList.contains('open')) {
            self.navbarButton.classList.remove('open');
            document.querySelector('body').classList.remove('overflow-hidden');
            self.node.classList.remove('js-navbar--opened');
        }

        if(self.navbarContent && self.navbarContent.dataset.opened === 'true') {
            
            gsap.to(self.navbarContent, {duration: 0.5, autoAlpha:0, right: '-100%', onComplete:function() {
                self.navbarContent.dataset.opened = "false";
                self.navbarContent.classList.add('hidden');
                self.navbarContent.removeAttribute('style');
            }});

        }

        if(! self.dropDownNodes) {
                return;
        }
    }
}



const navbarMenuConst = {
    navbar: null,
    timeout: false, // holder for timeout id
    delay: 250, // delay after event is "complete" to run callback
    initValue: null,

    init() {
        let self = this;

        let node = document.querySelector('.js-navbar');

        if (node) {
            self.navbar = new navbarMenu(node);
        }
    },

    reInit(self) {

        if(! self) {
            self = this;        
        }

        if (self.navbar) {
            self.navbar.closeMainMenu();
        }
        
        self.navbar.reInit();
    },
};

window.navbarMenuConst = navbarMenuConst;

window.navbarMenuConst.init();

window.menuScroll = function(node) {
    
    let target = node.href.substring(0, node.href.indexOf('#'));
    let current = window.location.href.substring(0, window.location.href.indexOf('#'));
    let gap = 80;
    if(window.innerWidth >= 1200) {
        gap = 112;
    }

    if(target === current) {
        node = document.getElementById(node.href.substring(node.href.lastIndexOf('#') + 1));
        node = node.querySelector('.container');
        let top = node.getBoundingClientRect().top + document.documentElement.scrollTop - gap - 24;

        if(window.innerWidth < 1200) {
            window.navbarMenuConst.navbar.closeMainMenu();
        }
        
        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });
       
        return false;
    }
}